export const API_BASE_URL = "https://catbackend.xraidigital.com/api/vitals";
// export const API_BASE_URL = "http://127.0.0.1:8000/api/vitals";

export function getCurrentUserId() {
    return localStorage.getItem("user_id") || "";
}